<template>
    <div class="product_information product_information_main_box_custom">
        <div
            class="accordian_detals contact_detail_wrap account_detail_left_rt"
        >
            <div class="acc">
                <div class="acc__card">
                    <div class="acc__title acc_head d-none">&nbsp;</div>
                    <div class="acc__panel order-list-page">
                        <div
                            v-for="(address, aIndex) in addresses"
                            :key="address.id"
                            class="mb-1"
                        >
                            <div
                                class="address-header d-flex justify-content-between align-items-center"
                                @click="toggleAddress(address)"
                            >
                                <div class="address-header-title text-truncate">
                                    <strong>Address {{ aIndex + 1 }}:</strong>
                                    {{ address.company_name }},
                                    {{ address.address_line1 }}
                                    <span v-if="address.address_line2">
                                        , {{ address.address_line2 }} </span
                                    >, {{ address.city }}, {{ address.state }}
                                    {{ address.zip }}
                                    <span v-if="address.phone"
                                        >, {{ address.phone }}</span
                                    >
                                    <span v-if="address.email"
                                        >, {{ address.email }}</span
                                    >
                                </div>
                                <!-- Shipping & Freight badge (same as email) -->

                                <div class="address-header-arrow">
                                    <div
                                        v-if="address.shipping_cost > 0"
                                        class="address-header-freight flex-shrink-0 mx-2"
                                        @click.stop
                                    >
                                        <span class="freight-label"
                                            >Shipping &amp; Freight:</span
                                        >
                                        <strong class="freight-value">{{
                                            formatPrice(
                                                parseFloat(
                                                    address.shipping_cost
                                                )
                                            )
                                        }}</strong>
                                    </div>
                                    <span
                                        class="arrow-icon"
                                        :class="{
                                            open: isAddressOpen(address)
                                        }"
                                    ></span>
                                </div>
                            </div>

                            <div
                                v-if="
                                    isAddressOpen(address) &&
                                    groupedByAddress[address.id] &&
                                    groupedByAddress[address.id].length
                                "
                                class="address-items-wrapper"
                            >
                                <div
                                    class="row base_pro_row_custom m-0"
                                    v-for="(
                                        group, groupIndex
                                    ) in groupedByAddress[address.id]"
                                    :key="
                                        address.id +
                                        '-' +
                                        groupIndex +
                                        '-' +
                                        (group.item.id ||
                                            group.item.unique_item_id)
                                    "
                                >
                                    <!-- col-md-12: full-width item row (matches admin structure) -->
                                    <div class="col-md-12 order-list-col">
                                        <div class="p_border pl-0">
                                            <div
                                                class="d-flex base_product_box_custom product_details_box"
                                            >
                                                <!-- LEFT group: image + product text -->
                                                <div class="d-flex">
                                                    <div
                                                        class="align-self-start"
                                                    >
                                                        <div
                                                            class="product-box"
                                                        >
                                                            <img
                                                                v-if="
                                                                    group.item
                                                                        .design_image
                                                                "
                                                                :src="
                                                                    group.item
                                                                        .design_image
                                                                        ? group.item.design_image.split(
                                                                              ','
                                                                          )[0]
                                                                        : group
                                                                              .item
                                                                              .design_image
                                                                "
                                                                class="img-fluid"
                                                            />
                                                            <img
                                                                v-else-if="
                                                                    group.item
                                                                        .product_image
                                                                "
                                                                :src="
                                                                    group.item
                                                                        .product_image
                                                                        .url
                                                                "
                                                                class="img-fluid"
                                                            />
                                                            <a
                                                                href="javascript:void(0)"
                                                                class="hover_search"
                                                                data-toggle="modal"
                                                                :data-target="
                                                                    '#imagepreview-byaddr-' +
                                                                    address.id +
                                                                    '-' +
                                                                    groupIndex
                                                                "
                                                            >
                                                                <img
                                                                    src="/maincss/images/zoom.svg"
                                                                    alt="Zoom"
                                                                />
                                                            </a>
                                                        </div>
                                                        <span
                                                            class="product_number"
                                                            >{{
                                                                group.item
                                                                    .product_number
                                                            }}</span
                                                        >
                                                    </div>

                                                    <div
                                                        class="align-self-start base_product_text_box_custom"
                                                    >
                                                        <div
                                                            class="color-black font-weight-bold pb_10 sub_pro_head_custom"
                                                        >
                                                            {{
                                                                group.item.name
                                                            }}
                                                        </div>
                                                        <div
                                                            class="color-line"
                                                            v-if="
                                                                group.item
                                                                    .Vendor &&
                                                                group.item
                                                                    .Vendor.name
                                                            "
                                                        >
                                                            <span
                                                                class="color-black font-weight-bold"
                                                                >Vendor:</span
                                                            >
                                                            {{
                                                                group.item
                                                                    .Vendor.name
                                                            }}
                                                        </div>
                                                        <div
                                                            class="product_details"
                                                        >
                                                            <div
                                                                class="color-line mt_12 d-flex align-items-center"
                                                            >
                                                                <span>{{
                                                                    group.sizes
                                                                        .map(
                                                                            (
                                                                                s
                                                                            ) =>
                                                                                `${s.sizeLabel}:${s.qty}`
                                                                        )
                                                                        .join(
                                                                            ", "
                                                                        )
                                                                }}</span>
                                                                <span
                                                                    class="ml-2"
                                                                    >| Total Qty
                                                                    :
                                                                    <span
                                                                        class="font-weight-bold"
                                                                        >{{
                                                                            group.totalQty
                                                                        }}</span
                                                                    ></span
                                                                >
                                                            </div>
                                                            <div
                                                                class="color-line mt_8 d-flex align-items-center"
                                                            >
                                                                <img
                                                                    v-if="
                                                                        group
                                                                            .item
                                                                            .color &&
                                                                        group
                                                                            .item
                                                                            .color
                                                                            .swatches
                                                                    "
                                                                    class="color_swatch_byaddr"
                                                                    :src="
                                                                        group
                                                                            .item
                                                                            .color
                                                                            .swatches
                                                                    "
                                                                    v-tooltip="{
                                                                        content:
                                                                            group
                                                                                .item
                                                                                .color
                                                                                .name,
                                                                        autoHide: false
                                                                    }"
                                                                    alt=""
                                                                />
                                                                <span
                                                                    v-else-if="
                                                                        group
                                                                            .item
                                                                            .color
                                                                    "
                                                                    :title="
                                                                        group
                                                                            .item
                                                                            .color
                                                                            .name
                                                                    "
                                                                    class="color_swatch_byaddr"
                                                                    :style="
                                                                        'background: ' +
                                                                        group
                                                                            .item
                                                                            .color
                                                                            .hex +
                                                                        ';'
                                                                    "
                                                                ></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- RIGHT: decorator logo + service (inside product_details_box as 2nd flex child) -->
                                                <div
                                                    class="d-flex justify-content-center align-items-center pr-2"
                                                >
                                                    <div
                                                        class="brand-logo-wrapper"
                                                    >
                                                        <div
                                                            v-if="
                                                                getDecoratorLogo(
                                                                    group.item
                                                                )
                                                            "
                                                            class="mb-1"
                                                        >
                                                            <img
                                                                :src="
                                                                    getDecoratorLogo(
                                                                        group.item
                                                                    )
                                                                "
                                                                alt="Brand logo"
                                                                class="brand-logo-img"
                                                            />
                                                        </div>
                                                        <div
                                                            class="decoration-service-name"
                                                        >
                                                            {{
                                                                getDecorationServiceName(
                                                                    group.item
                                                                )
                                                            }}
                                                        </div>
                                                        <div
                                                            v-if="
                                                                getEstimatedShippingDate(
                                                                    group.item
                                                                )
                                                            "
                                                            class="decoration-shipdate mt-0"
                                                        >
                                                            Est. Ship Date:
                                                            {{
                                                                formatEstimatedShippingDate(
                                                                    getEstimatedShippingDate(
                                                                        group.item
                                                                    )
                                                                )
                                                            }}
                                                        </div>
                                                        <div
                                                            v-if="isTShirt24HourItem(group.item)"
                                                            class="hours_info_block_image mt-2"
                                                        >
                                                            <img src="/maincss/images/icons/hour-tshirts.png" alt="24 hours T-Shirt" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Name/Number table (below product row, above imprint locations) -->
                                            <NameNumberTable
                                                :rows="
                                                    getSplitNameNumberTable(
                                                        address.id,
                                                        group
                                                    )
                                                "
                                                :item-context="group.item"
                                                :show-export="true"
                                                csv-file-name="NameAndNumberByAddress.csv"
                                                :csv-header="'Name,Number,Size,Product Name,Product Color,Name Font,Name Size,Name Color,Number Font,Number Size,Number Color\\n'"
                                            />

                                            <!-- Imprint locations F/B/L/R row -->
                                            <div
                                                class="p_border decoration_main_box imprint-locations-wrapper"
                                            >
                                                <ImprintLocationsRow
                                                    :locations="
                                                        getImprintLocations(
                                                            group.item
                                                        )
                                                    "
                                                    :modal-target="
                                                        '#imagepreview-byaddr-' +
                                                        address.id +
                                                        '-' +
                                                        groupIndex
                                                    "
                                                    @open-modal="
                                                        onImprintOpenCanvasModal(
                                                            address.id,
                                                            groupIndex,
                                                            $event
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Old artwork col (hidden via CSS) -->
                                    <div class="col-md-4 order-list-col-sec">
                                        <div class="artwork-old-block">
                                            <div
                                                class="p_border decoration_main_box"
                                            >
                                                <div class="d-flex">
                                                    <div
                                                        class="align-self-start"
                                                    >
                                                        <div
                                                            v-if="
                                                                artworkImageUrl(
                                                                    group.item
                                                                )
                                                            "
                                                            class="product-box mb_10"
                                                        >
                                                            <img
                                                                v-if="
                                                                    getDecoration(
                                                                        group.item
                                                                    ).art_work
                                                                "
                                                                :src="
                                                                    getDecoration(
                                                                        group.item
                                                                    ).art_work
                                                                "
                                                                class="img-fluid"
                                                            />
                                                            <img
                                                                v-else-if="
                                                                    group.item
                                                                        .front_art_url
                                                                "
                                                                :src="
                                                                    group.item
                                                                        .front_art_url
                                                                "
                                                                class="img-fluid"
                                                            />
                                                            <p
                                                                class="hover_searc_p_custom"
                                                            >
                                                                <a
                                                                    href="#"
                                                                    class="hover_search"
                                                                    data-toggle="modal"
                                                                    :data-target="
                                                                        '#artworkpreview-byaddr-' +
                                                                        address.id +
                                                                        '-' +
                                                                        groupIndex
                                                                    "
                                                                >
                                                                    <img
                                                                        class="search_hover_img_tag"
                                                                        src="/maincss/images/zoom.svg"
                                                                        alt=" "
                                                                    />
                                                                </a>
                                                            </p>
                                                        </div>
                                                        <div
                                                            class="product_details"
                                                        >
                                                            <div
                                                                class="color-line"
                                                            >
                                                                <div>
                                                                    Decoration
                                                                    Service:
                                                                    {{
                                                                        getDecorationServiceName(
                                                                            group.item
                                                                        )
                                                                    }}
                                                                </div>
                                                                <div
                                                                    v-if="
                                                                        group.estimatedShippingDate ||
                                                                        getEstimatedShippingDate(
                                                                            group.item
                                                                        )
                                                                    "
                                                                    style="
                                                                        font-size: 14px;
                                                                        color: #666;
                                                                        margin-top: 4px;
                                                                    "
                                                                >
                                                                    Est. Ship
                                                                    Date:
                                                                    {{
                                                                        formatEstimatedShippingDate(
                                                                            group.estimatedShippingDate ||
                                                                                getEstimatedShippingDate(
                                                                                    group.item
                                                                                )
                                                                        )
                                                                    }}
                                                                </div>
                                                                <ul
                                                                    v-if="
                                                                        group
                                                                            .item
                                                                            .decoration_colors &&
                                                                        group
                                                                            .item
                                                                            .decoration_colors
                                                                            .length >
                                                                            0
                                                                    "
                                                                    class="standard_colors"
                                                                >
                                                                    <span
                                                                        class="mr-1 font_size_14"
                                                                    >
                                                                        Decoration
                                                                        Colors:
                                                                    </span>
                                                                    <li
                                                                        v-for="(
                                                                            color,
                                                                            cIdx
                                                                        ) in group
                                                                            .item
                                                                            .decoration_colors"
                                                                        :key="
                                                                            cIdx
                                                                        "
                                                                        :style="
                                                                            'background-color:' +
                                                                            (color.hex ||
                                                                                color) +
                                                                            ';'
                                                                        "
                                                                        v-tooltip="{
                                                                            content:
                                                                                color.name
                                                                                    ? color.name +
                                                                                      ' ' +
                                                                                      (color.hex ||
                                                                                          '')
                                                                                    : color.hex ||
                                                                                      color,
                                                                            autoHide: false
                                                                        }"
                                                                    ></li>
                                                                </ul>
                                                            </div>
                                                            <div
                                                                class="mr-1 mt-2"
                                                            >
                                                                <a
                                                                    v-if="
                                                                        showDesignImages(
                                                                            group
                                                                                .item
                                                                                .design_images
                                                                        )
                                                                    "
                                                                    type="button"
                                                                    class="images-popup-btn btn btn_outline_primary buttons"
                                                                    :data-target="
                                                                        '#canvas-images-model-byaddr-' +
                                                                        address.id +
                                                                        '-' +
                                                                        groupIndex
                                                                    "
                                                                    data-toggle="modal"
                                                                >
                                                                    Images
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <ArtworkPreviewModal
                                        :modal-id="
                                            'canvas-images-model-byaddr-' +
                                            address.id +
                                            '-' +
                                            groupIndex
                                        "
                                        :design-images="
                                            getDesignImagesForCanvasModal(
                                                group.item,
                                                address.id + '-' + groupIndex
                                            )
                                        "
                                        :on-close="
                                            () =>
                                                onCloseCanvasModalByAddress(
                                                    address.id,
                                                    groupIndex
                                                )
                                        "
                                    />

                                    <div
                                        class="modal fade cart_preview"
                                        :id="
                                            'imagepreview-byaddr-' +
                                            address.id +
                                            '-' +
                                            groupIndex
                                        "
                                        data-backdrop="static"
                                        data-keyboard="false"
                                        tabindex="-1"
                                        aria-labelledby="staticBackdropLabel"
                                        aria-hidden="true"
                                    >
                                        <div
                                            class="modal-dialog modal-dialog-centered cart_modal_s"
                                            style="
                                                max-width: 823px;
                                                width: 100%;
                                            "
                                        >
                                            <div class="modal-content">
                                                <div
                                                    class="modal-header border-bottom-0"
                                                >
                                                    <div
                                                        class="order-number"
                                                        v-if="
                                                            orderDetail &&
                                                            orderDetail.unique_order_id
                                                        "
                                                    >
                                                        <h3>
                                                            Order Number-:
                                                            <span>
                                                                <b
                                                                    >#{{
                                                                        orderDetail.unique_order_id
                                                                    }}</b
                                                                >
                                                            </span>
                                                        </h3>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        class="close"
                                                        data-dismiss="modal"
                                                        aria-label="Close"
                                                    >
                                                        <img
                                                            src="/maincss/images/cancel.svg"
                                                            alt=" "
                                                        />
                                                    </button>
                                                </div>
                                                <div
                                                    v-if="
                                                        group.item
                                                            .design_images &&
                                                        parseDesignImagesForPreview(
                                                            group.item
                                                                .design_images
                                                        ).length > 0
                                                    "
                                                    class="modal-body pt-0"
                                                >
                                                    <div
                                                        class="canvas_auto_preview_images"
                                                        style="
                                                            display: flex;
                                                            margin-top: 20px;
                                                        "
                                                    >
                                                        <div
                                                            class="mx-auto preview-image"
                                                            style="
                                                                padding-left: 10px;
                                                            "
                                                            v-for="(
                                                                design_img, dIdx
                                                            ) in parseDesignImagesForPreview(
                                                                group.item
                                                                    .design_images
                                                            )"
                                                            :key="dIdx"
                                                        >
                                                            <h4>
                                                                {{
                                                                    (
                                                                        design_img.label ||
                                                                        ""
                                                                    ).replace(
                                                                        /(?:^|\s|-)\S/g,
                                                                        (x) =>
                                                                            x.toUpperCase()
                                                                    )
                                                                }}
                                                            </h4>
                                                            <div
                                                                class="product-box text-center mt_10"
                                                            >
                                                                <img
                                                                    v-if="
                                                                        design_img &&
                                                                        design_img.url
                                                                    "
                                                                    :src="
                                                                        design_img.url
                                                                    "
                                                                    :style="
                                                                        group
                                                                            .item
                                                                            .color &&
                                                                        group
                                                                            .item
                                                                            .color
                                                                            .hex
                                                                            ? 'background-color:' +
                                                                              group
                                                                                  .item
                                                                                  .color
                                                                                  .hex +
                                                                              ';'
                                                                            : ''
                                                                    "
                                                                    class="img-fluid"
                                                                />
                                                                <img
                                                                    v-else-if="
                                                                        group
                                                                            .item
                                                                            .product_image
                                                                    "
                                                                    :src="
                                                                        group
                                                                            .item
                                                                            .product_image
                                                                            .url
                                                                    "
                                                                    class="img-fluid"
                                                                />
                                                            </div>
                                                            <div
                                                                v-if="
                                                                    group.item
                                                                        .design_area_inches &&
                                                                    parseDesignAreaInches(
                                                                        group
                                                                            .item
                                                                            .design_area_inches
                                                                    ).length > 0
                                                                "
                                                            >
                                                                <template
                                                                    v-for="(
                                                                        design_inches,
                                                                        inchIdx
                                                                    ) in parseDesignAreaInches(
                                                                        group
                                                                            .item
                                                                            .design_area_inches
                                                                    )"
                                                                >
                                                                    <h4
                                                                        class="dimension_text"
                                                                        :key="
                                                                            inchIdx
                                                                        "
                                                                        v-if="
                                                                            (
                                                                                design_img.label ||
                                                                                ''
                                                                            ).replace(
                                                                                /(?:^|\s|-)\S/g,
                                                                                (
                                                                                    x
                                                                                ) =>
                                                                                    x.toUpperCase()
                                                                            ) ===
                                                                                (design_inches.label ||
                                                                                    '') &&
                                                                            'widthIn' in
                                                                                design_inches
                                                                        "
                                                                    >
                                                                        Imprint
                                                                        Area
                                                                        {{
                                                                            design_inches.widthIn
                                                                        }}
                                                                        <span
                                                                            >&#8243;</span
                                                                        >
                                                                        <b
                                                                            >&#215;</b
                                                                        >
                                                                        {{
                                                                            design_inches.heightIn
                                                                        }}
                                                                        <span
                                                                            >&#8243;</span
                                                                        >
                                                                    </h4>
                                                                </template>
                                                            </div>
                                                            <div
                                                                class="product_details mb-2 name_number_text"
                                                                v-if="
                                                                    hasNameNumberForView(
                                                                        group.item,
                                                                        design_img.label
                                                                    )
                                                                "
                                                            >
                                                                <p class="mb-0">
                                                                    Name Color:
                                                                    <span>
                                                                        <b>
                                                                            {{
                                                                                hasNameForView(
                                                                                    group.item,
                                                                                    design_img.label
                                                                                )
                                                                                    ? getNameNumberColor(
                                                                                          group.item,
                                                                                          "nameColor",
                                                                                          normalizeLocationForNameNumber(
                                                                                              design_img.label
                                                                                          )
                                                                                      ) ||
                                                                                      "—"
                                                                                    : "—"
                                                                            }}
                                                                        </b>
                                                                    </span>
                                                                    | Number
                                                                    Color:
                                                                    <span>
                                                                        <b>
                                                                            {{
                                                                                hasNumberForView(
                                                                                    group.item,
                                                                                    design_img.label
                                                                                )
                                                                                    ? getNameNumberColor(
                                                                                          group.item,
                                                                                          "numberColor",
                                                                                          normalizeLocationForNameNumber(
                                                                                              design_img.label
                                                                                          )
                                                                                      ) ||
                                                                                      "—"
                                                                                    : "—"
                                                                            }}
                                                                        </b>
                                                                    </span>
                                                                </p>
                                                                <p class="mb-0">
                                                                    Name Size:
                                                                    <span>
                                                                        <b>
                                                                            {{
                                                                                hasNameForView(
                                                                                    group.item,
                                                                                    design_img.label
                                                                                )
                                                                                    ? getNameNumberSize(
                                                                                          group.item,
                                                                                          "nameSize",
                                                                                          normalizeLocationForNameNumber(
                                                                                              design_img.label
                                                                                          )
                                                                                      ) ||
                                                                                      "—"
                                                                                    : "—"
                                                                            }}
                                                                        </b>
                                                                    </span>
                                                                    | Number
                                                                    Size:
                                                                    <span>
                                                                        <b>
                                                                            {{
                                                                                hasNumberForView(
                                                                                    group.item,
                                                                                    design_img.label
                                                                                )
                                                                                    ? getNameNumberSize(
                                                                                          group.item,
                                                                                          "numberSize",
                                                                                          normalizeLocationForNameNumber(
                                                                                              design_img.label
                                                                                          )
                                                                                      ) ||
                                                                                      "—"
                                                                                    : "—"
                                                                            }}
                                                                        </b>
                                                                    </span>
                                                                </p>
                                                                <p class="mb-0">
                                                                    Name Font:
                                                                    <span>
                                                                        <b>
                                                                            {{
                                                                                hasNameForView(
                                                                                    group.item,
                                                                                    design_img.label
                                                                                )
                                                                                    ? getNameNumberFont(
                                                                                          group.item,
                                                                                          "nameFont",
                                                                                          normalizeLocationForNameNumber(
                                                                                              design_img.label
                                                                                          )
                                                                                      ) ||
                                                                                      "—"
                                                                                    : "—"
                                                                            }}
                                                                        </b>
                                                                    </span>
                                                                    | Number
                                                                    Font:
                                                                    <span>
                                                                        <b>
                                                                            {{
                                                                                hasNumberForView(
                                                                                    group.item,
                                                                                    design_img.label
                                                                                )
                                                                                    ? getNameNumberFont(
                                                                                          group.item,
                                                                                          "numberFont",
                                                                                          normalizeLocationForNameNumber(
                                                                                              design_img.label
                                                                                          )
                                                                                      ) ||
                                                                                      "—"
                                                                                    : "—"
                                                                            }}
                                                                        </b>
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    v-else
                                                    class="modal-body pt-0"
                                                >
                                                    <div
                                                        class="canvas_auto_preview_images new_canvas_images1"
                                                        style="
                                                            display: flex;
                                                            margin-top: 20px;
                                                        "
                                                    >
                                                        <div
                                                            class="mx-auto preview-image"
                                                            style="
                                                                padding-left: 10px;
                                                            "
                                                        >
                                                            <div
                                                                class="product-box"
                                                            >
                                                                <img
                                                                    v-if="
                                                                        group
                                                                            .item
                                                                            .design_image
                                                                    "
                                                                    :src="
                                                                        group
                                                                            .item
                                                                            .design_image
                                                                            ? group.item.design_image.split(
                                                                                  ','
                                                                              )[0]
                                                                            : group
                                                                                  .item
                                                                                  .design_image
                                                                    "
                                                                    class="img-fluid"
                                                                />
                                                                <img
                                                                    v-else-if="
                                                                        group
                                                                            .item
                                                                            .product_image
                                                                    "
                                                                    :src="
                                                                        group
                                                                            .item
                                                                            .product_image
                                                                            .url
                                                                    "
                                                                    class="img-fluid"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="modal fade cart_preview"
                                        :id="
                                            'artworkpreview-byaddr-' +
                                            address.id +
                                            '-' +
                                            groupIndex
                                        "
                                        data-backdrop="static"
                                        data-keyboard="false"
                                        tabindex="-1"
                                        aria-labelledby="staticBackdropLabel"
                                        aria-hidden="true"
                                    >
                                        <div
                                            class="modal-dialog modal-dialog-centered order_details_art_work_popup_custom"
                                        >
                                            <div class="modal-content">
                                                <div
                                                    class="modal-header border-bottom-0 py-2 mb_30"
                                                >
                                                    <button
                                                        type="button"
                                                        class="close p-0"
                                                        data-dismiss="modal"
                                                        aria-label="Close"
                                                    >
                                                        <img
                                                            src="/maincss/images/cancel.svg"
                                                            alt=""
                                                        />
                                                    </button>
                                                </div>
                                                <div class="modal-body pt-0">
                                                    <div
                                                        class="mx-auto preview-image text-center mb_26"
                                                    >
                                                        <img
                                                            v-if="
                                                                getDecoration(
                                                                    group.item
                                                                ).art_work
                                                            "
                                                            :src="
                                                                getDecoration(
                                                                    group.item
                                                                ).art_work
                                                            "
                                                            alt=""
                                                        />
                                                        <img
                                                            v-else-if="
                                                                group.item
                                                                    .front_art_url
                                                            "
                                                            :src="
                                                                group.item
                                                                    .front_art_url
                                                            "
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="costSummary"
                class="byaddress-total-section row mx-0 total_price mt-3"
            >
                <div class="col-md-6"></div>
                <div class="col-md-6">
                    <div class="row justify-content-end mx-0 cart-total">
                        <div
                            class="col-md-7 total-sec-col byaddress-total-col pl-2 pr-4 pb-3"
                        >
                            <div
                                class="border-right-0 base_product_total_box_custom_main_box byaddress-fee-summary"
                            >
                                <div class="product_details">
                                    <div class="row">
                                        <div
                                            class="col-md-12"
                                            v-if="costSummary.baseFeeTotal > 0"
                                        >
                                            <div
                                                class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row"
                                            >
                                                <span
                                                    class="total_p_custom byaddress-label"
                                                    >{{
                                                        costSummary.baseFeeLabel
                                                    }}</span
                                                >
                                                <span
                                                    class="order_no byaddress-value"
                                                    >{{
                                                        formatPrice(
                                                            costSummary.baseFeeTotal
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12"
                                            v-if="
                                                costSummary.runChargeTotal > 0
                                            "
                                        >
                                            <div
                                                class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row"
                                            >
                                                <span
                                                    class="total_p_custom byaddress-label"
                                                    >{{
                                                        costSummary.runChargeLabel
                                                    }}</span
                                                >
                                                <span
                                                    class="order_no byaddress-value"
                                                    >{{
                                                        formatPrice(
                                                            costSummary.runChargeTotal
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12"
                                            v-if="
                                                costSummary.setupDesignTotal > 0
                                            "
                                        >
                                            <div
                                                class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row"
                                            >
                                                <span
                                                    class="total_p_custom byaddress-label"
                                                    >{{
                                                        costSummary.setupDesignLabel
                                                    }}</span
                                                >
                                                <span
                                                    class="order_no byaddress-value"
                                                    >{{
                                                        formatPrice(
                                                            costSummary.setupDesignTotal
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12"
                                            v-if="costSummary.packingTotal > 0"
                                        >
                                            <div
                                                class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row"
                                            >
                                                <span
                                                    class="total_p_custom byaddress-label"
                                                >
                                                    <div
                                                        class="d-flex align-items-center"
                                                    >
                                                        <span
                                                            class="text-nowrap"
                                                            >{{
                                                                costSummary.packingLabel
                                                            }}</span
                                                        >
                                                        <div
                                                            class="tooltip-wrapper"
                                                            v-if="
                                                                costSummary.packingBreakdown &&
                                                                costSummary
                                                                    .packingBreakdown
                                                                    .length > 0
                                                            "
                                                            @click.stop="
                                                                toggleOrderTooltip(
                                                                    'packingKitting'
                                                                )
                                                            "
                                                        >
                                                            <svg
                                                                class="ml_6 info-icon-svg"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                aria-hidden="true"
                                                                focusable="false"
                                                            >
                                                                <path
                                                                    d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                                <path
                                                                    d="M8 5.33203V8.66536"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                                <path
                                                                    d="M8 10.668H8.00599"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                            </svg>
                                                            <div
                                                                v-if="
                                                                    orderTooltipVisible ===
                                                                    'packingKitting'
                                                                "
                                                                class="tooltip-content is-visible"
                                                            >
                                                                <div
                                                                    class="tooltip-header"
                                                                >
                                                                    <h4>
                                                                        {{
                                                                            costSummary.packingLabel
                                                                        }}
                                                                        Breakdown
                                                                    </h4>
                                                                    <svg
                                                                        class="close-icon"
                                                                        @click.stop="
                                                                            closeOrderTooltip
                                                                        "
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        stroke-width="2"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round"
                                                                    >
                                                                        <line
                                                                            x1="18"
                                                                            y1="6"
                                                                            x2="6"
                                                                            y2="18"
                                                                        ></line>
                                                                        <line
                                                                            x1="6"
                                                                            y1="6"
                                                                            x2="18"
                                                                            y2="18"
                                                                        ></line>
                                                                    </svg>
                                                                </div>
                                                                <div
                                                                    class="tooltip-body"
                                                                >
                                                                    <table
                                                                        class="base-fee-table"
                                                                    >
                                                                        <thead>
                                                                            <tr>
                                                                                <th>
                                                                                    Fee
                                                                                </th>
                                                                                <th>
                                                                                    Qty
                                                                                </th>
                                                                                <th>
                                                                                    Amt
                                                                                </th>
                                                                                <th>
                                                                                    Total
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr
                                                                                v-for="(
                                                                                    item,
                                                                                    index
                                                                                ) in costSummary.packingBreakdown"
                                                                                :key="
                                                                                    index
                                                                                "
                                                                            >
                                                                                <td>
                                                                                    {{
                                                                                        item.name ||
                                                                                        item.service_name ||
                                                                                        "Packaging, Kitting and Handling Service"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.quantity ||
                                                                                        item.qty ||
                                                                                        "-"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.amt ||
                                                                                        item.amount
                                                                                            ? formatPrice(
                                                                                                  parseFloat(
                                                                                                      item.amt ||
                                                                                                          item.amount ||
                                                                                                          0
                                                                                                  )
                                                                                              )
                                                                                            : "-"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        formatPrice(
                                                                                            parseFloat(
                                                                                                item.total ||
                                                                                                    item.amt ||
                                                                                                    item.amount ||
                                                                                                    0
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr
                                                                                v-if="
                                                                                    costSummary.packingTotal >
                                                                                    0
                                                                                "
                                                                                class="total-row"
                                                                            >
                                                                                <td
                                                                                    colspan="3"
                                                                                >
                                                                                    <strong
                                                                                        >Total</strong
                                                                                    >
                                                                                </td>
                                                                                <td>
                                                                                    <strong
                                                                                        >{{
                                                                                            formatPrice(
                                                                                                costSummary.packingTotal
                                                                                            )
                                                                                        }}</strong
                                                                                    >
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                                <span
                                                    class="order_no byaddress-value"
                                                    >{{
                                                        formatPrice(
                                                            costSummary.packingTotal
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                        <!-- Sub Total: border top + bottom, bold (same as admin) -->
                                        <div
                                            class="col-md-12 byaddress-subtotal-block mb-1"
                                        >
                                            <div
                                                class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row byaddress-subtotal-row"
                                            >
                                                <span
                                                    class="total_p_custom byaddress-label"
                                                    >Sub Total</span
                                                >
                                                <span
                                                    class="order_no byaddress-value"
                                                >
                                                    {{
                                                        formatPrice(
                                                            costSummary.subTotal !=
                                                                null
                                                                ? Number(
                                                                      costSummary.subTotal
                                                                  )
                                                                : Number(
                                                                      costSummary.baseFeeTotal ||
                                                                          0
                                                                  ) +
                                                                      Number(
                                                                          costSummary.runChargeTotal ||
                                                                              0
                                                                      ) +
                                                                      Number(
                                                                          costSummary.setupDesignTotal ||
                                                                              0
                                                                      ) +
                                                                      Number(
                                                                          costSummary.packingTotal ||
                                                                              0
                                                                      )
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 pb-2"
                                            v-if="costSummary.shippingTotal > 0"
                                        >
                                            <div
                                                class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row"
                                            >
                                                <span
                                                    class="total_p_custom byaddress-label"
                                                >
                                                    <div
                                                        class="d-flex align-items-center"
                                                    >
                                                        <span
                                                            class="text-nowrap"
                                                            >{{
                                                                costSummary.shippingLabel
                                                            }}</span
                                                        >
                                                        <div
                                                            class="tooltip-wrapper"
                                                            v-if="
                                                                costSummary.shippingBreakdown &&
                                                                costSummary
                                                                    .shippingBreakdown
                                                                    .length > 0
                                                            "
                                                            @click.stop="
                                                                toggleOrderTooltip(
                                                                    'shipping'
                                                                )
                                                            "
                                                        >
                                                            <svg
                                                                class="ml_6 info-icon-svg"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                aria-hidden="true"
                                                                focusable="false"
                                                            >
                                                                <path
                                                                    d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                                <path
                                                                    d="M8 5.33203V8.66536"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                                <path
                                                                    d="M8 10.668H8.00599"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                            </svg>
                                                            <div
                                                                v-if="
                                                                    orderTooltipVisible ===
                                                                    'shipping'
                                                                "
                                                                class="tooltip-content is-visible"
                                                            >
                                                                <div
                                                                    class="tooltip-header"
                                                                >
                                                                    <h4>
                                                                        {{
                                                                            costSummary.shippingLabel
                                                                        }}
                                                                        Breakdown
                                                                    </h4>
                                                                    <svg
                                                                        class="close-icon"
                                                                        @click.stop="
                                                                            closeOrderTooltip
                                                                        "
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        stroke-width="2"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round"
                                                                    >
                                                                        <line
                                                                            x1="18"
                                                                            y1="6"
                                                                            x2="6"
                                                                            y2="18"
                                                                        ></line>
                                                                        <line
                                                                            x1="6"
                                                                            y1="6"
                                                                            x2="18"
                                                                            y2="18"
                                                                        ></line>
                                                                    </svg>
                                                                </div>
                                                                <div
                                                                    class="tooltip-body"
                                                                >
                                                                    <table
                                                                        class="base-fee-table"
                                                                    >
                                                                        <thead>
                                                                            <tr>
                                                                                <th>
                                                                                    Fee
                                                                                </th>
                                                                                <th>
                                                                                    Qty
                                                                                </th>
                                                                                <th>
                                                                                    Amt
                                                                                </th>
                                                                                <th>
                                                                                    Total
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr
                                                                                v-for="(
                                                                                    item,
                                                                                    index
                                                                                ) in costSummary.shippingBreakdown"
                                                                                :key="
                                                                                    index
                                                                                "
                                                                            >
                                                                                <td>
                                                                                    {{
                                                                                        item.name ||
                                                                                        item.service_name ||
                                                                                        "Shipping and Freight Service"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.type ===
                                                                                            "shipping_method" ||
                                                                                        item.name ===
                                                                                            "Shipping Method Charge" ||
                                                                                        item.name ===
                                                                                            "Shipping Charge"
                                                                                            ? "-"
                                                                                            : item.quantity ||
                                                                                              item.qty ||
                                                                                              "-"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.type ===
                                                                                            "shipping_method" ||
                                                                                        item.name ===
                                                                                            "Shipping Method Charge" ||
                                                                                        item.name ===
                                                                                            "Shipping Charge"
                                                                                            ? "-"
                                                                                            : item.amt ||
                                                                                              item.amount
                                                                                            ? formatPrice(
                                                                                                  parseFloat(
                                                                                                      item.amt ||
                                                                                                          item.amount ||
                                                                                                          0
                                                                                                  )
                                                                                              )
                                                                                            : "-"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        formatPrice(
                                                                                            parseFloat(
                                                                                                item.total ||
                                                                                                    item.amt ||
                                                                                                    item.amount ||
                                                                                                    0
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr
                                                                                v-if="
                                                                                    costSummary.shippingTotal >
                                                                                    0
                                                                                "
                                                                                class="total-row"
                                                                            >
                                                                                <td
                                                                                    colspan="3"
                                                                                >
                                                                                    <strong
                                                                                        >Total</strong
                                                                                    >
                                                                                </td>
                                                                                <td>
                                                                                    <strong
                                                                                        >{{
                                                                                            formatPrice(
                                                                                                costSummary.shippingTotal
                                                                                            )
                                                                                        }}</strong
                                                                                    >
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                                <span
                                                    class="order_no byaddress-value"
                                                    >{{
                                                        formatPrice(
                                                            costSummary.shippingTotal
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12"
                                            v-if="costSummary.salesTaxTotal > 0"
                                        >
                                            <div
                                                class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row"
                                            >
                                                <span
                                                    class="total_p_custom byaddress-label"
                                                >
                                                    <div
                                                        class="d-flex align-items-center"
                                                    >
                                                        <span
                                                            class="text-nowrap"
                                                            >{{
                                                                costSummary.salesTaxLabel
                                                            }}</span
                                                        >
                                                        <div
                                                            class="tooltip-wrapper"
                                                            v-if="
                                                                costSummary.salesTaxBreakdown &&
                                                                costSummary
                                                                    .salesTaxBreakdown
                                                                    .length > 0
                                                            "
                                                            @click.stop="
                                                                toggleOrderTooltip(
                                                                    'salesTax'
                                                                )
                                                            "
                                                        >
                                                            <svg
                                                                class="ml_6 info-icon-svg"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                aria-hidden="true"
                                                                focusable="false"
                                                            >
                                                                <path
                                                                    d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                                <path
                                                                    d="M8 5.33203V8.66536"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                                <path
                                                                    d="M8 10.668H8.00599"
                                                                    stroke="#929292"
                                                                    stroke-width="1.3"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                            </svg>
                                                            <div
                                                                v-if="
                                                                    orderTooltipVisible ===
                                                                    'salesTax'
                                                                "
                                                                class="tooltip-content is-visible"
                                                            >
                                                                <div
                                                                    class="tooltip-header"
                                                                >
                                                                    <h4>
                                                                        {{
                                                                            costSummary.salesTaxLabel
                                                                        }}
                                                                        Breakdown
                                                                    </h4>
                                                                    <svg
                                                                        class="close-icon"
                                                                        @click.stop="
                                                                            closeOrderTooltip
                                                                        "
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        stroke-width="2"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round"
                                                                    >
                                                                        <line
                                                                            x1="18"
                                                                            y1="6"
                                                                            x2="6"
                                                                            y2="18"
                                                                        ></line>
                                                                        <line
                                                                            x1="6"
                                                                            y1="6"
                                                                            x2="18"
                                                                            y2="18"
                                                                        ></line>
                                                                    </svg>
                                                                </div>
                                                                <div
                                                                    class="tooltip-body"
                                                                >
                                                                    <table
                                                                        class="base-fee-table"
                                                                    >
                                                                        <thead>
                                                                            <tr>
                                                                                <th>
                                                                                    Fee
                                                                                </th>
                                                                                <th>
                                                                                    Qty
                                                                                </th>
                                                                                <th>
                                                                                    Amt
                                                                                </th>
                                                                                <th>
                                                                                    Total
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr
                                                                                v-for="(
                                                                                    item,
                                                                                    index
                                                                                ) in costSummary.salesTaxBreakdown"
                                                                                :key="
                                                                                    index
                                                                                "
                                                                            >
                                                                                <td>
                                                                                    {{
                                                                                        item.name ||
                                                                                        item.service_name ||
                                                                                        "Sales Tax Service"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.type ===
                                                                                            "sales_tax" ||
                                                                                        item.name ===
                                                                                            "Sales Tax"
                                                                                            ? "-"
                                                                                            : item.quantity ||
                                                                                              item.qty ||
                                                                                              "-"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.type ===
                                                                                            "sales_tax" ||
                                                                                        item.name ===
                                                                                            "Sales Tax"
                                                                                            ? "-"
                                                                                            : item.amt ||
                                                                                              item.amount
                                                                                            ? formatPrice(
                                                                                                  parseFloat(
                                                                                                      item.amt ||
                                                                                                          item.amount ||
                                                                                                          0
                                                                                                  )
                                                                                              )
                                                                                            : "-"
                                                                                    }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        formatPrice(
                                                                                            parseFloat(
                                                                                                item.total ||
                                                                                                    item.amt ||
                                                                                                    item.amount ||
                                                                                                    0
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                            <tr
                                                                                v-if="
                                                                                    costSummary.salesTaxTotal >
                                                                                    0
                                                                                "
                                                                                class="total-row"
                                                                            >
                                                                                <td
                                                                                    colspan="3"
                                                                                >
                                                                                    <strong
                                                                                        >Total</strong
                                                                                    >
                                                                                </td>
                                                                                <td>
                                                                                    <strong
                                                                                        >{{
                                                                                            formatPrice(
                                                                                                costSummary.salesTaxTotal
                                                                                            )
                                                                                        }}</strong
                                                                                    >
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                                <span
                                                    class="order_no byaddress-value"
                                                    >{{
                                                        formatPrice(
                                                            costSummary.salesTaxTotal
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                        <!-- Grand Total: border top, bold (matches admin byaddress-item-subtotal-block) -->
                                        <div
                                            class="col-md-12 byaddress-item-subtotal-block"
                                        >
                                            <div
                                                class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row byaddress-item-subtotal-row"
                                            >
                                                <span
                                                    class="total_p_custom byaddress-label"
                                                    >Grand Total</span
                                                >
                                                <span
                                                    class="order_no byaddress-value"
                                                    >{{
                                                        formatPrice(
                                                            costSummary.grandTotal
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImprintLocationsRow from "./order-items-by-address/ImprintLocationsRow.vue";
import ArtworkPreviewModal from "./order-items-by-address/ArtworkPreviewModal.vue";
import NameNumberTable from "./order-items-by-address/NameNumberTable.vue";
import { isTShirt24HourFromItem } from "@/common/product24Hour.util";

/** True if design_images JSON includes any canvas_images[].filled_artwork_url (per-layer export). */
function designImagesJsonHasFilledArtwork(raw) {
    if (!raw) return false;
    try {
        const arr = typeof raw === "string" ? JSON.parse(raw) : raw;
        if (!Array.isArray(arr)) return false;
        return arr.some(
            (di) =>
                di &&
                Array.isArray(di.canvas_images) &&
                di.canvas_images.some(
                    (ci) =>
                        ci &&
                        ci.filled_artwork_url != null &&
                        String(ci.filled_artwork_url).trim() !== ""
                )
        );
    } catch (e) {
        return false;
    }
}

export default {
    name: "OrderItemsByAddress",
    components: { ImprintLocationsRow, ArtworkPreviewModal, NameNumberTable },
    data() {
        return {
            openAddresses: {},
            orderTooltipVisible: null,
            selectedCanvasLocation: null,
            selectedCanvasModalKey: null
        };
    },
    props: {
        addresses: {
            type: Array,
            required: true
        },
        itemsByAddress: {
            type: Object,
            required: true
        },
        orderDetail: {
            type: Object,
            required: false,
            default: null
        },
        costSummary: {
            type: Object,
            required: false,
            default: null
        },
        formatPrice: {
            type: Function,
            required: false,
            default: (v) => (v != null ? String(v) : "")
        }
    },
    computed: {
        groupedByAddress() {
            const result = {};

            Object.keys(this.itemsByAddress || {}).forEach((addrId) => {
                const rows = this.itemsByAddress[addrId] || [];
                const byItem = {};

                const baseOrderItems =
                    (this.orderDetail && this.orderDetail.items) || [];

                rows.forEach((row) => {
                    if (!row || !row.item) return;
                    const item = row.item;
                    const colorId =
                        item.color && item.color.id != null
                            ? item.color.id
                            : "";
                    const splitOrderItemId =
                        row && row.split && row.split.order_item_id != null
                            ? row.split.order_item_id
                            : "";
                    const keyParts = [
                        item.id,
                        colorId,
                        item.unique_item_id,
                        item.build_id,
                        item.group_assembly_id
                    ].filter(
                        (v) => v !== null && v !== undefined && String(v) !== ""
                    );
                    const key =
                        (keyParts.length > 0 ? keyParts.join("_") : "") ||
                        [
                            item.product_number || "",
                            splitOrderItemId || "",
                            row.sizeLabel || ""
                        ].join("_");

                    if (!byItem[key]) {
                        let enrichedItem = item;
                        if (baseOrderItems && baseOrderItems.length > 0) {
                            const itemColorId =
                                item && item.color && item.color.id != null
                                    ? String(item.color.id)
                                    : "";
                            const itemBuildId =
                                item && item.build_id != null
                                    ? String(item.build_id)
                                    : "";
                            const itemGroupAssemblyId =
                                item && item.group_assembly_id != null
                                    ? String(item.group_assembly_id)
                                    : "";
                            const match = baseOrderItems.find((oi) => {
                                if (!oi) return false;
                                const sameUniqueItemId =
                                    oi.unique_item_id != null &&
                                    item.unique_item_id != null &&
                                    String(oi.unique_item_id) ===
                                        String(item.unique_item_id);
                                const sameProductId =
                                    oi.id != null &&
                                    item.id != null &&
                                    String(oi.id) === String(item.id);
                                if (!sameUniqueItemId && !sameProductId) {
                                    return false;
                                }

                                const oiColorId =
                                    oi.color && oi.color.id != null
                                        ? String(oi.color.id)
                                        : "";
                                const oiBuildId =
                                    oi.build_id != null
                                        ? String(oi.build_id)
                                        : "";
                                const oiGroupAssemblyId =
                                    oi.group_assembly_id != null
                                        ? String(oi.group_assembly_id)
                                        : "";

                                const hasColorOnEitherSide =
                                    itemColorId !== "" || oiColorId !== "";
                                if (
                                    hasColorOnEitherSide &&
                                    itemColorId !== oiColorId
                                ) {
                                    return false;
                                }

                                if (
                                    itemBuildId !== "" &&
                                    oiBuildId !== "" &&
                                    itemBuildId !== oiBuildId
                                ) {
                                    return false;
                                }

                                if (
                                    itemGroupAssemblyId !== "" &&
                                    oiGroupAssemblyId !== "" &&
                                    itemGroupAssemblyId !== oiGroupAssemblyId
                                ) {
                                    return false;
                                }

                                return true;
                            });
                            if (match && match.design_images) {
                                // Prefer row item's design_images when it carries filled_artwork_url
                                // (order line from address payload); avoid overwriting with parent match missing it.
                                const useRowDesignImages =
                                    designImagesJsonHasFilledArtwork(
                                        item.design_images
                                    );
                                enrichedItem = Object.assign({}, item, {
                                    design_images: useRowDesignImages
                                        ? item.design_images
                                        : match.design_images
                                });
                            }
                        }
                        byItem[key] = {
                            item: enrichedItem,
                            sizes: [],
                            totalQty: 0,
                            estimatedShippingDate:
                                (row.split &&
                                    row.split.estimated_shipping_date) ||
                                item.estimated_shipping_date ||
                                null
                        };
                    }

                    const qty =
                        row.split &&
                        typeof row.split.split_quantity === "number"
                            ? row.split.split_quantity
                            : parseInt(
                                  row.split && row.split.split_quantity,
                                  10
                              ) || 0;

                    byItem[key].sizes.push({
                        sizeLabel: row.sizeLabel,
                        qty
                    });
                    byItem[key].totalQty += qty;
                });

                result[addrId] = Object.values(byItem);
            });

            return result;
        }
    },
    methods: {
        isAddressOpen(address) {
            const id = address && address.id;
            if (!id) return true;
            if (this.openAddresses[id] === undefined) {
                return true;
            }
            return this.openAddresses[id];
        },
        toggleAddress(address) {
            const id = address && address.id;
            if (!id) return;
            const current = this.isAddressOpen(address);
            this.$set(this.openAddresses, id, !current);
        },
        toggleOrderTooltip(type) {
            this.orderTooltipVisible =
                this.orderTooltipVisible === type ? null : type;
        },
        closeOrderTooltip() {
            this.orderTooltipVisible = null;
        },
        getDecorationTypeAbbr(item) {
            if (!item) return "—";
            // Prefer master service_code (set by admin in master services configuration)
            if (item.decoration) {
                let dec = item.decoration;
                if (typeof dec === "string") {
                    try {
                        dec = JSON.parse(dec);
                    } catch (e) {
                        dec = null;
                    }
                }
                if (dec) {
                    const sc =
                        dec.service_code ||
                        (dec.master_service && dec.master_service.service_code);
                    if (sc && String(sc).trim())
                        return String(sc).trim().toUpperCase();
                }
            }
            // Fallback: derive abbreviation from decoration service name
            const name = (this.getDecorationServiceName(item) || "")
                .toLowerCase()
                .trim();
            if (name.indexOf("screen") >= 0 || name.indexOf("print") >= 0)
                return "SP";
            if (name.indexOf("embroid") >= 0) return "EMB";
            if (name.indexOf("deboss") >= 0) return "DEB";
            if (name.indexOf("heat") >= 0) return "HT";
            if (name.length >= 2) return name.substring(0, 3).toUpperCase();
            return name ? name.toUpperCase() : "—";
        },
        dedupeLocationColors(colors) {
            if (!Array.isArray(colors) || colors.length === 0) return [];
            const seen = new Set();
            const out = [];
            colors.forEach((color, idx) => {
                if (!color) return;
                const hex =
                    color.hex != null
                        ? String(color.hex).trim().toLowerCase()
                        : "";
                const name =
                    color.name != null
                        ? String(color.name).trim().toLowerCase()
                        : "";
                const key = hex || name || "idx:" + idx;
                if (seen.has(key)) return;
                seen.add(key);
                out.push(color);
            });
            return out;
        },
        getImprintLocations(item) {
            if (!item) return [];
            const type = this.getDecorationTypeAbbr(item);
            let designImages = [];
            if (item.design_images) {
                try {
                    const parsed =
                        typeof item.design_images === "string"
                            ? JSON.parse(item.design_images)
                            : item.design_images;
                    designImages = Array.isArray(parsed) ? parsed : [];
                } catch (e) {}
            }
            const labelToCode = {
                front: "F",
                back: "B",
                left: "L",
                right: "R"
            };
            const order = ["front", "back", "left", "right"];
            const seen = new Set();
            const out = [];
            const fontNameJson = item ? this._getFontSizes(item, "name") : null;
            const fontNumberJson = item
                ? this._getFontSizes(item, "number")
                : null;

            designImages.forEach((di) => {
                const label =
                    (di && di.label && String(di.label).toLowerCase().trim()) ||
                    "";
                const loc =
                    order.find((o) => label === o || label.indexOf(o) === 0) ||
                    label ||
                    "front";
                const code = labelToCode[loc] || loc.charAt(0).toUpperCase();
                if (seen.has(code)) return;
                seen.add(code);
                let thumb = "";
                const layers =
                    di && Array.isArray(di.canvas_images) ? di.canvas_images : [];
                const ciFilled = layers.find(
                    (ci) =>
                        ci &&
                        ci.filled_artwork_url != null &&
                        String(ci.filled_artwork_url).trim() !== ""
                );
                if (ciFilled) {
                    thumb = String(ciFilled.filled_artwork_url).trim();
                } else if (di) {
                    thumb =
                        (di.design_image_path_png &&
                            String(di.design_image_path_png).trim()) ||
                        (typeof di.design_image === "string" &&
                        di.design_image.trim().indexOf("http") === 0
                            ? di.design_image.trim()
                            : "") ||
                        (di.url && String(di.url).trim()) ||
                        (typeof di.design_image === "string"
                            ? di.design_image.trim()
                            : "") ||
                        "";
                }
                if (!thumb && layers.length) {
                    thumb = layers[0].image_path || "";
                }
                let locColors = [];
                if (di && Array.isArray(di.colors) && di.colors.length) {
                    locColors = di.colors;
                } else if (
                    di &&
                    Array.isArray(di.canvas_images) &&
                    di.canvas_images.length &&
                    Array.isArray(di.canvas_images[0].colors) &&
                    di.canvas_images[0].colors.length
                ) {
                    locColors = di.canvas_images[0].colors;
                }

                if (!locColors.length) {
                    const locationKey =
                        code === "F"
                            ? "front"
                            : code === "B"
                            ? "back"
                            : code === "L"
                            ? "left"
                            : "right";
                    const nameColorHex =
                        fontNameJson &&
                        fontNameJson[locationKey] &&
                        fontNameJson[locationKey].nameFontColor;
                    const numberColorHex =
                        fontNumberJson &&
                        fontNumberJson[locationKey] &&
                        fontNumberJson[locationKey].numberFontColor;

                    const tmp = [];
                    const diLabel = di && di.label;
                    if (nameColorHex && this.hasNameForView(item, diLabel)) {
                        tmp.push({ name: "Name", hex: String(nameColorHex) });
                    }
                    if (
                        numberColorHex &&
                        this.hasNumberForView(item, diLabel)
                    ) {
                        tmp.push({
                            name: "Number",
                            hex: String(numberColorHex)
                        });
                    }
                    if (tmp.length) locColors = tmp;
                }
                locColors = this.dedupeLocationColors(locColors);

                out.push({
                    code,
                    label: (di && di.label) || loc,
                    thumbnailUrl: thumb,
                    type,
                    colors: locColors
                });
            });
            const dec = this.getDecoration(item);
            if (out.length === 0 && (dec.art_work || item.front_art_url)) {
                out.push({
                    code: "F",
                    label: "Front",
                    thumbnailUrl: dec.art_work || item.front_art_url || "",
                    type,
                    colors: []
                });
            }
            return out;
        },
        getDecoration(item) {
            if (!item) return {};
            return (
                item.NewOrderItemDecoration ||
                item.NewOrderItemDecorations ||
                {}
            );
        },
        artworkImageUrl(item) {
            const dec = this.getDecoration(item);
            return (dec && dec.art_work) || (item && item.front_art_url);
        },
        getSplitNameNumberTable(addressId, group) {
            const addrId = addressId != null ? String(addressId) : null;
            if (
                !addrId ||
                !this.itemsByAddress ||
                !this.itemsByAddress[addrId]
            ) {
                return [];
            }
            const rows = this.itemsByAddress[addrId] || [];
            const table = [];
            const seenPayloads = new Set();
            const sizeIdSet = new Set(
                ((group && group.item && group.item.sizes) || [])
                    .map((s) => (s && s.id != null ? String(s.id) : null))
                    .filter(Boolean)
            );
            rows.forEach((row) => {
                if (!row || !row.split) return;
                const splitOrderItemId =
                    row.split && row.split.order_item_id != null
                        ? String(row.split.order_item_id)
                        : null;
                if (splitOrderItemId && sizeIdSet.size > 0) {
                    // Split shipment: product-wise mapping by exact order_item_id.
                    if (!sizeIdSet.has(splitOrderItemId)) return;
                } else {
                    // Standard order: rows don't carry split order_item_id, so map by group item identity.
                    const rowItem = row.item || {};
                    const groupItem = (group && group.item) || {};
                    const sameUniqueItemId =
                        rowItem.unique_item_id != null &&
                        groupItem.unique_item_id != null &&
                        String(rowItem.unique_item_id) ===
                            String(groupItem.unique_item_id);
                    const sameProductId =
                        rowItem.id != null &&
                        groupItem.id != null &&
                        String(rowItem.id) === String(groupItem.id);
                    const rowColorId =
                        rowItem.color && rowItem.color.id != null
                            ? String(rowItem.color.id)
                            : "";
                    const groupColorId =
                        groupItem.color && groupItem.color.id != null
                            ? String(groupItem.color.id)
                            : "";
                    if (
                        !sameUniqueItemId &&
                        !(sameProductId && rowColorId === groupColorId)
                    ) {
                        return;
                    }
                }
                // Use only the split-address-specific name_and_number_json.
                // Do NOT fall back to item.name_and_number_json (global) —
                // split.name_and_number_json = null means no personalization was assigned to this address.
                const rawSplitNameNumber =
                    row.split && row.split.name_and_number_json != null
                        ? row.split.name_and_number_json
                        : null;
                const payloadKey =
                    rawSplitNameNumber != null
                        ? typeof rawSplitNameNumber === "string"
                            ? rawSplitNameNumber
                            : JSON.stringify(rawSplitNameNumber)
                        : "";
                if (
                    !splitOrderItemId &&
                    payloadKey &&
                    seenPayloads.has(payloadKey)
                ) {
                    return;
                }
                if (!splitOrderItemId && payloadKey) {
                    seenPayloads.add(payloadKey);
                }
                const rowItem = row.item || (group && group.item) || {};
                const productName =
                    (rowItem.MainNewSubProduct &&
                        rowItem.MainNewSubProduct.name) ||
                    rowItem.product_number ||
                    "";
                const productColor =
                    (rowItem.color && rowItem.color.name) ||
                    rowItem.t_shirt_color ||
                    "";
                const buildExportRow = (
                    entry,
                    fallbackName,
                    fallbackNumber
                ) => {
                    const location = this.normalizeLocationForNameNumber(
                        (entry && (entry.location || entry.label)) || "front"
                    );
                    return {
                        name: (entry && entry.name) || fallbackName || "",
                        number: (entry && entry.number) || fallbackNumber || "",
                        size: (entry && entry.size) || row.sizeLabel || "",
                        productName,
                        productColor,
                        nameFont:
                            (entry && entry.nameFont) ||
                            this.getNameNumberFont(
                                rowItem,
                                "nameFont",
                                location
                            ) ||
                            "",
                        nameSize:
                            (entry && entry.nameSize) ||
                            this.getNameNumberSize(
                                rowItem,
                                "nameSize",
                                location
                            ) ||
                            "",
                        nameColor:
                            (entry && entry.nameColor) ||
                            this.getNameNumberColor(
                                rowItem,
                                "nameColor",
                                location
                            ) ||
                            "",
                        numberFont:
                            (entry && entry.numberFont) ||
                            this.getNameNumberFont(
                                rowItem,
                                "numberFont",
                                location
                            ) ||
                            "",
                        numberSize:
                            (entry && entry.numberSize) ||
                            this.getNameNumberSize(
                                rowItem,
                                "numberSize",
                                location
                            ) ||
                            "",
                        numberColor:
                            (entry && entry.numberColor) ||
                            this.getNameNumberColor(
                                rowItem,
                                "numberColor",
                                location
                            ) ||
                            ""
                    };
                };
                const nn = this.normalizeNameAndNumberJson(rawSplitNameNumber);
                if (nn && Array.isArray(nn) && nn.length > 0) {
                    nn.forEach((entry) => {
                        table.push(buildExportRow(entry, "", ""));
                    });
                } else if (row.name || row.number) {
                    table.push(
                        buildExportRow(null, row.name || "", row.number || "")
                    );
                }
            });
            return table;
        },
        normalizeNameAndNumberJson(raw) {
            if (!raw) return [];
            let parsed =
                typeof raw === "string"
                    ? (() => {
                          try {
                              return JSON.parse(raw);
                          } catch (e) {
                              return null;
                          }
                      })()
                    : raw;
            if (!parsed) return [];
            if (Array.isArray(parsed)) {
                return parsed.filter(
                    (nn) =>
                        nn &&
                        (String(nn.name || "").trim() !== "" ||
                            String(nn.number || "").trim() !== "")
                );
            }
            if (
                parsed &&
                typeof parsed === "object" &&
                !Array.isArray(parsed)
            ) {
                const locationKeys = ["front", "back", "left", "right"];
                const selectedLocs = parsed.selected_name_number || {};

                // Determine which locations hold names and which hold numbers.
                // Fall back to "all locations" when selected_name_number is absent.
                const hasFilter = Object.keys(selectedLocs).length > 0;
                const nameLocations = new Set();
                const numberLocations = new Set();
                locationKeys.forEach((loc) => {
                    const sel = selectedLocs[loc] || {};
                    if (!hasFilter || sel.name) nameLocations.add(loc);
                    if (!hasFilter || sel.number) numberLocations.add(loc);
                });

                // Collect name entries and number entries separately (in order).
                const nameRows = [];
                const numberRows = [];
                locationKeys.forEach((loc) => {
                    const locRows = Array.isArray(parsed[loc])
                        ? parsed[loc]
                        : [];
                    locRows.forEach((r) => {
                        if (!r) return;
                        const n = String(r.name || "").trim();
                        const num = String(r.number || "").trim();
                        // Entry has BOTH (same-location combined) → push as full row.
                        if (n && num) {
                            nameRows.push({
                                name: n,
                                number: num,
                                size: r.size || "",
                                location: loc
                            });
                            return;
                        }
                        if (n && nameLocations.has(loc)) {
                            nameRows.push({
                                name: n,
                                number: "",
                                size: r.size || "",
                                location: loc
                            });
                        }
                        if (num && numberLocations.has(loc)) {
                            numberRows.push({
                                name: "",
                                number: num,
                                size: r.size || "",
                                location: loc
                            });
                        }
                    });
                });

                // Merge: pair nameRows[i] with numberRows[i] by position.
                const count = Math.max(nameRows.length, numberRows.length);
                if (count === 0) return [];
                const result = [];
                for (let i = 0; i < count; i++) {
                    const nr = nameRows[i] || {
                        name: "",
                        number: "",
                        size: ""
                    };
                    const nu = numberRows[i] || {
                        name: "",
                        number: "",
                        size: ""
                    };
                    result.push({
                        name: nr.name || nu.name,
                        number: nu.number || nr.number,
                        size: nr.size || nu.size,
                        location: nr.location || nu.location || "front"
                    });
                }
                return result;
            }
            return [];
        },
        getItemForModal(address, group) {
            if (!address || !group || !group.item) return null;
            if (!this.itemsByAddress || !this.itemsByAddress[address.id])
                return null;
            const rows = this.itemsByAddress[address.id];
            const groupItem = group.item;
            const groupColorId =
                groupItem && groupItem.color && groupItem.color.id != null
                    ? String(groupItem.color.id)
                    : "";
            const groupBuildId =
                groupItem && groupItem.build_id != null
                    ? String(groupItem.build_id)
                    : "";
            const groupAssemblyId =
                groupItem && groupItem.group_assembly_id != null
                    ? String(groupItem.group_assembly_id)
                    : "";
            const row = rows.find((r) => {
                if (!r || !r.item) return false;
                const rowItem = r.item;
                const sameUniqueItemId =
                    rowItem.unique_item_id != null &&
                    groupItem.unique_item_id != null &&
                    String(rowItem.unique_item_id) ===
                        String(groupItem.unique_item_id);
                const sameProductId =
                    rowItem.id != null &&
                    groupItem.id != null &&
                    String(rowItem.id) === String(groupItem.id);
                if (!sameUniqueItemId && !sameProductId) {
                    return false;
                }

                const rowColorId =
                    rowItem.color && rowItem.color.id != null
                        ? String(rowItem.color.id)
                        : "";
                const rowBuildId =
                    rowItem.build_id != null ? String(rowItem.build_id) : "";
                const rowAssemblyId =
                    rowItem.group_assembly_id != null
                        ? String(rowItem.group_assembly_id)
                        : "";

                const hasColorOnEitherSide =
                    groupColorId !== "" || rowColorId !== "";
                if (hasColorOnEitherSide && groupColorId !== rowColorId) {
                    return false;
                }

                if (
                    groupBuildId !== "" &&
                    rowBuildId !== "" &&
                    groupBuildId !== rowBuildId
                ) {
                    return false;
                }

                if (
                    groupAssemblyId !== "" &&
                    rowAssemblyId !== "" &&
                    groupAssemblyId !== rowAssemblyId
                ) {
                    return false;
                }

                return true;
            });
            const splitNameNumberJson =
                row &&
                row.split &&
                row.split.name_and_number_json != null &&
                row.split.name_and_number_json !== ""
                    ? row.split.name_and_number_json
                    : null;
            const baseNameNumberJson =
                group.item && group.item.name_and_number_json != null
                    ? group.item.name_and_number_json
                    : null;
            const parsedSplitNameNumber =
                this.parseNameNumberPayload(splitNameNumberJson);
            const parsedBaseNameNumber =
                this.parseNameNumberPayload(baseNameNumberJson);

            // Split payload is authoritative only when it is location-structured
            // and actually carries usable name data; otherwise keep base item payload
            // (matches admin behavior where grouped item data is used in modal).
            if (
                !parsedSplitNameNumber ||
                Array.isArray(parsedSplitNameNumber) ||
                (!this.hasAnyNameInNameNumberPayload(parsedSplitNameNumber) &&
                    this.hasAnyNameInNameNumberPayload(parsedBaseNameNumber))
            ) {
                return group.item;
            }
            return Object.assign({}, group.item, {
                name_and_number_json: splitNameNumberJson
            });
        },
        parseNameNumberPayload(raw) {
            if (raw == null || raw === "") return null;
            if (typeof raw === "string") {
                try {
                    return JSON.parse(raw);
                } catch (e) {
                    return null;
                }
            }
            return raw;
        },
        hasAnyNameInNameNumberPayload(payload) {
            if (!payload) return false;
            if (Array.isArray(payload)) {
                return payload.some(
                    (row) => row && String(row.name || "").trim() !== ""
                );
            }
            if (typeof payload === "object") {
                const locationKeys = ["front", "back", "left", "right"];
                return locationKeys.some((loc) => {
                    const rows = Array.isArray(payload[loc])
                        ? payload[loc]
                        : [];
                    return rows.some(
                        (row) => row && String(row.name || "").trim() !== ""
                    );
                });
            }
            return false;
        },
        showDesignImages(data) {
            if (data) {
                try {
                    let json = JSON.parse(data);
                    json = json.filter(
                        (img) =>
                            img.canvas_images && img.canvas_images.length > 0
                    );
                    if (json.length > 0) return true;
                } catch (e) {}
            }
            return false;
        },
        isTShirt24HourItem(item) {
            return isTShirt24HourFromItem(item);
        },

        getDecorationServiceName(item) {
            if (!item || !item.decoration) return "";
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return "";
                }
            }
            if (decoration) {
                if (decoration.ecomm_display) return decoration.ecomm_display;
                if (
                    decoration.master_service &&
                    decoration.master_service.ecomm_display
                ) {
                    return decoration.master_service.ecomm_display;
                }
            }
            return "";
        },
        getDecoratorLogo(item) {
            if (!item) return "";
            const decorator = item.Decorator;
            if (decorator && decorator.logo_file) return decorator.logo_file;
            const vendor = item.Vendor;
            if (vendor && vendor.logo_file) return vendor.logo_file;
            return "";
        },
        getEstimatedShippingDate(item) {
            if (item && item.estimated_shipping_date)
                return item.estimated_shipping_date;
            if (
                item &&
                item.sizes &&
                Array.isArray(item.sizes) &&
                item.sizes.length
            ) {
                const parentSize = item.sizes.find((size) => size.parent === 1);
                if (parentSize && parentSize.estimated_shipping_date)
                    return parentSize.estimated_shipping_date;
                if (item.sizes[0] && item.sizes[0].estimated_shipping_date)
                    return item.sizes[0].estimated_shipping_date;
            }
            return null;
        },
        formatEstimatedShippingDate(dateString) {
            if (!dateString) return "";
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString;
                const mm = String(date.getMonth() + 1).padStart(2, "0");
                const dd = String(date.getDate()).padStart(2, "0");
                const yyyy = date.getFullYear();
                return `${mm}/${dd}/${yyyy}`;
            } catch (e) {
                return dateString;
            }
        },
        parseDesignImages(designImages) {
            if (!designImages) return [];
            try {
                const parsed =
                    typeof designImages === "string"
                        ? JSON.parse(designImages)
                        : designImages;
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        },
        onImprintOpenCanvasModal(addrId, groupIdx, locationCode) {
            this.selectedCanvasLocation = locationCode || null;
            this.selectedCanvasModalKey = addrId + "-" + groupIdx;
            this.$nextTick(() => {
                const sel =
                    "#canvas-images-model-byaddr-" + addrId + "-" + groupIdx;
                if (window.$ && typeof window.$.fn.modal === "function") {
                    window.$(sel).modal("show");
                }
            });
        },
        onCloseCanvasModalByAddress(addrId, groupIdx) {
            this.selectedCanvasLocation = null;
            this.selectedCanvasModalKey = null;
            const sel =
                "#canvas-images-model-byaddr-" + addrId + "-" + groupIdx;
            if (window.$ && typeof window.$.fn.modal === "function") {
                window.$(sel).modal("hide");
            }
        },
        getDesignImagesForCanvasModal(item, modalKey) {
            const raw = this.parseDesignImages(item.design_images);
            const withCanvas = (raw || []).map((di) => {
                if (
                    di &&
                    (!di.canvas_images || di.canvas_images.length === 0) &&
                    di.design_image
                ) {
                    return Object.assign({}, di, {
                        canvas_images: [
                            {
                                image_path: di.design_image,
                                image_name: di.label || "",
                                width_inch: null,
                                height_inch: null
                            }
                        ]
                    });
                }
                return di;
            });
            if (
                this.selectedCanvasModalKey !== modalKey ||
                !this.selectedCanvasLocation
            ) {
                return withCanvas;
            }
            return this.getDesignImagesFilteredByLocation(
                withCanvas,
                this.selectedCanvasLocation
            );
        },
        getDesignImagesFilteredByLocation(designImagesArray, locationCode) {
            if (!locationCode || !Array.isArray(designImagesArray))
                return designImagesArray || [];
            const codeToLabel = {
                F: "front",
                B: "back",
                L: "left",
                R: "right"
            };
            const label = codeToLabel[locationCode];
            if (!label) return designImagesArray;
            return designImagesArray.filter(
                (di) =>
                    di &&
                    di.label &&
                    String(di.label).toLowerCase().trim().indexOf(label) === 0
            );
        },
        parseDesignImagesForPreview(designImages) {
            if (!designImages) return [];
            try {
                const parsed =
                    typeof designImages === "string"
                        ? JSON.parse(designImages)
                        : designImages;
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        },
        parseDesignAreaInches(designAreaInches) {
            if (!designAreaInches) return [];
            try {
                const parsed =
                    typeof designAreaInches === "string"
                        ? JSON.parse(designAreaInches)
                        : designAreaInches;
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        },
        existsNameAndNumber(data, type) {
            if (!data || !Array.isArray(data)) return false;
            return data.some(
                (nn) => nn && String(nn[type] || "").trim() !== ""
            );
        },
        normalizeLocationForNameNumber(location) {
            const s = (location || "").toString().toLowerCase().trim();
            const standard = ["front", "back", "left", "right"];
            const found = standard.find((k) => s === k || s.indexOf(k) === 0);
            return found || s;
        },
        getSelectedNameNumber(item) {
            if (!item) return {};
            if (item.name_and_number_json != null) {
                let nn = item.name_and_number_json;
                if (typeof nn === "string") {
                    try {
                        nn = JSON.parse(nn) || {};
                    } catch (e) {
                        nn = null;
                    }
                }
                if (nn && nn.selected_name_number) {
                    return nn.selected_name_number;
                }
            }
            if (item.selected_name_number != null) {
                let snn = item.selected_name_number;
                if (typeof snn === "string") {
                    try {
                        snn = JSON.parse(snn) || {};
                    } catch (e) {
                        return {};
                    }
                }
                if (snn && typeof snn === "object") {
                    return snn;
                }
            }
            if (
                item.sizes &&
                Array.isArray(item.sizes) &&
                item.sizes.length > 0
            ) {
                for (let i = 0; i < item.sizes.length; i++) {
                    const sizeRow = item.sizes[i];
                    if (!sizeRow) continue;

                    if (sizeRow.name_and_number_json != null) {
                        let sizeNn = sizeRow.name_and_number_json;
                        if (typeof sizeNn === "string") {
                            try {
                                sizeNn = JSON.parse(sizeNn) || {};
                            } catch (e) {
                                sizeNn = null;
                            }
                        }
                        if (sizeNn && sizeNn.selected_name_number) {
                            return sizeNn.selected_name_number;
                        }
                    }

                    if (sizeRow.selected_name_number != null) {
                        let sizeSnn = sizeRow.selected_name_number;
                        if (typeof sizeSnn === "string") {
                            try {
                                sizeSnn = JSON.parse(sizeSnn) || {};
                            } catch (e) {
                                sizeSnn = null;
                            }
                        }
                        if (sizeSnn && typeof sizeSnn === "object") {
                            return sizeSnn;
                        }
                    }
                }
            }
            return {};
        },
        hasNameNumberForView(item, location) {
            if (!item) return false;
            const loc = this.normalizeLocationForNameNumber(location || "");
            if (!loc) return false;
            const snn = this.getSelectedNameNumber(item);
            const locSel = snn[loc];
            const hasSelectionData =
                snn && typeof snn === "object" && Object.keys(snn).length > 0;
            if (
                hasSelectionData &&
                (!locSel || (locSel.name !== true && locSel.number !== true))
            ) {
                return false;
            }
            let nn = item.name_and_number_json;
            if (
                !nn &&
                item.sizes &&
                Array.isArray(item.sizes) &&
                item.sizes.length > 0
            ) {
                for (let s of item.sizes) {
                    if (s.name_and_number_json) {
                        nn = s.name_and_number_json;
                        break;
                    }
                }
            }
            if (typeof nn === "string") {
                try {
                    nn = JSON.parse(nn);
                } catch (e) {
                    nn = null;
                }
            }
            if (nn && typeof nn === "object" && !Array.isArray(nn)) {
                const key =
                    Object.keys(nn).find(
                        (k) => this.normalizeLocationForNameNumber(k) === loc
                    ) || loc;
                const arr = Array.isArray(nn[key]) ? nn[key] : [];
                if (
                    arr.some(
                        (e) =>
                            e &&
                            (String(e.name || "").trim() !== "" ||
                                String(
                                    e.number != null ? e.number : ""
                                ).trim() !== "")
                    )
                ) {
                    return true;
                }
            } else if (
                nn &&
                Array.isArray(nn) &&
                nn.length > 0 &&
                (this.existsNameAndNumber(nn, "name") ||
                    this.existsNameAndNumber(nn, "number"))
            ) {
                if (!hasSelectionData || !locSel) return false;
                return true;
            }
            return false;
        },
        hasNameForView(item, location) {
            if (!item) return false;
            const loc = this.normalizeLocationForNameNumber(location || "");
            if (!loc) return false;
            const snn = this.getSelectedNameNumber(item);
            const locSel = snn[loc];
            if (locSel && locSel.name === false) return false;
            let nn = item.name_and_number_json;
            if (
                !nn &&
                item.sizes &&
                Array.isArray(item.sizes) &&
                item.sizes.length > 0
            ) {
                for (let s of item.sizes) {
                    if (s.name_and_number_json) {
                        nn = s.name_and_number_json;
                        break;
                    }
                }
            }
            if (typeof nn === "string") {
                try {
                    nn = JSON.parse(nn);
                } catch (e) {
                    nn = null;
                }
            }
            if (nn && typeof nn === "object" && !Array.isArray(nn)) {
                const key =
                    Object.keys(nn).find(
                        (k) => this.normalizeLocationForNameNumber(k) === loc
                    ) || loc;
                const arr = Array.isArray(nn[key]) ? nn[key] : [];
                return arr.some((e) => e && String(e.name || "").trim() !== "");
            }
            if (nn && Array.isArray(nn)) {
                const hasSelectionData =
                    snn &&
                    typeof snn === "object" &&
                    Object.keys(snn).length > 0;
                if (!hasSelectionData || !locSel || locSel.name !== true)
                    return false;
                return this.existsNameAndNumber(nn, "name");
            }
            return false;
        },
        hasNumberForView(item, location) {
            if (!item) return false;
            const loc = this.normalizeLocationForNameNumber(location || "");
            if (!loc) return false;
            const snn = this.getSelectedNameNumber(item);
            const locSel = snn[loc];
            if (locSel && locSel.number === false) return false;
            let nn = item.name_and_number_json;
            if (
                !nn &&
                item.sizes &&
                Array.isArray(item.sizes) &&
                item.sizes.length > 0
            ) {
                for (let s of item.sizes) {
                    if (s.name_and_number_json) {
                        nn = s.name_and_number_json;
                        break;
                    }
                }
            }
            if (typeof nn === "string") {
                try {
                    nn = JSON.parse(nn);
                } catch (e) {
                    nn = null;
                }
            }
            if (nn && typeof nn === "object" && !Array.isArray(nn)) {
                const key =
                    Object.keys(nn).find(
                        (k) => this.normalizeLocationForNameNumber(k) === loc
                    ) || loc;
                const arr = Array.isArray(nn[key]) ? nn[key] : [];
                return arr.some(
                    (e) =>
                        e &&
                        e.number != null &&
                        (e.number === 0 ||
                            e.number === "0" ||
                            String(e.number).trim() !== "")
                );
            }
            if (nn && Array.isArray(nn)) {
                const hasSelectionData =
                    snn &&
                    typeof snn === "object" &&
                    Object.keys(snn).length > 0;
                if (!hasSelectionData || !locSel || locSel.number !== true)
                    return false;
                return this.existsNameAndNumber(nn, "number");
            }
            return false;
        },
        _getFontSizes(item, which) {
            const raw =
                which === "name"
                    ? item.font_color_sizes_name
                    : item.font_color_sizes_number;
            if (!raw) return null;
            return typeof raw === "string"
                ? (() => {
                      try {
                          return JSON.parse(raw);
                      } catch (e) {
                          return null;
                      }
                  })()
                : raw;
        },
        _isPerLocationFontSizes(obj) {
            if (!obj || typeof obj !== "object" || Array.isArray(obj))
                return false;
            return ["front", "back", "left", "right"].some((k) =>
                Object.keys(obj).includes(k)
            );
        },
        _getFontSizesForLocation(item, which, location) {
            const raw = this._getFontSizes(item, which);
            if (!raw) return null;
            if (location && this._isPerLocationFontSizes(raw)) {
                const locNorm = this.normalizeLocationForNameNumber(location);
                const key = Object.keys(raw).find(
                    (k) => this.normalizeLocationForNameNumber(k) === locNorm
                );
                if (key && raw[key]) return raw[key];
            }
            return raw;
        },
        getNameNumberColor(item, key, location) {
            const nnRaw = item && item.name_and_number_json;
            const first =
                nnRaw && Array.isArray(nnRaw) && nnRaw[0]
                    ? nnRaw[0][key]
                    : null;
            if (first != null && first !== "") return first;
            const nameObj = this._getFontSizesForLocation(
                item,
                "name",
                location
            );
            const numObj = this._getFontSizesForLocation(
                item,
                "number",
                location
            );
            if (key === "nameColor" && nameObj) return nameObj.nameFontColor;
            if (key === "numberColor" && numObj) return numObj.numberFontColor;
            return null;
        },
        getNameNumberSize(item, key, location) {
            const nnRaw = item && item.name_and_number_json;
            const first =
                nnRaw && Array.isArray(nnRaw) && nnRaw[0]
                    ? nnRaw[0][key]
                    : null;
            if (first != null && first !== "") return first;
            const nameObj = this._getFontSizesForLocation(
                item,
                "name",
                location
            );
            const numObj = this._getFontSizesForLocation(
                item,
                "number",
                location
            );
            if (key === "nameSize" && nameObj) return nameObj.nameFontSize;
            if (key === "numberSize" && numObj) return numObj.numberFontSize;
            return null;
        },
        getNameNumberFont(item, key, location) {
            const nnRaw = item && item.name_and_number_json;
            const first =
                nnRaw && Array.isArray(nnRaw) && nnRaw[0]
                    ? nnRaw[0][key]
                    : null;
            if (first != null && first !== "") return first;
            const nameObj = this._getFontSizesForLocation(
                item,
                "name",
                location
            );
            const numObj = this._getFontSizesForLocation(
                item,
                "number",
                location
            );
            if (key === "nameFont" && nameObj) return nameObj.nameFontFamily;
            if (key === "numberFont" && numObj) return numObj.numberFontFamily;
            return null;
        }
    }
};
</script>

<style scoped>
.address-header {
    background-color: #f5f5f5;
    border: 1px solid #dedede;
    padding: 12px 16px;
    font-size: 14px;
    color: #414141;
    font-weight: 500;
    line-height: 16px;
    cursor: pointer;
    padding-top: 16px;
}

.address-header-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.address-header-arrow {
    margin-left: 8px;
    display: flex;
    gap: 8px;
    align-items: center;
}

/* Shipping & Freight badge in address header (mirrors email display) */
.address-header-freight {
    font-size: 13px;
    white-space: nowrap;
    color: #121212;
}
.address-header-freight .freight-label {
    font-weight: 600;
    color: #121212;
    margin-right: 4px;
}
.address-header-freight .freight-value {
    color: #121212;
}

.arrow-icon {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #999;
    border-bottom: 2px solid #999;
    transform: rotate(45deg);
    transition: transform 0.15s ease;
}

.arrow-icon.open {
    transform: rotate(-135deg);
}

/* Row separation (match admin: full border on each item card) */
.base_pro_row_custom {
    padding-top: 16px;
    padding-bottom: 16px;
    border: 1px solid #bebebe66;
}

.order-list-col,
.order-list-col-sec {
    align-self: stretch;
}

.imprint-locations-wrapper {
    margin-top: 0;
}

.brand-logo-wrapper {
    min-width: 120px;
}

.brand-logo-img {
    max-width: 120px;
    max-height: 50px;
    object-fit: contain;
    display: inline-block;
}

.decoration-service-name {
    font-size: 13px;
    color: #555;
    font-weight: 500;
    text-align: left;
    margin-top: 8px;
}

.decoration-shipdate {
    font-size: 13px;
    color: #666;
    margin-top: 4px;
}

.name-number-data {
    border-collapse: collapse;
    border: 1px solid #d7c6c6;
    font-size: 12px;
    width: 100%;
    max-width: 260px;
}

.name-number-data .data-heading {
    background-color: #f5f5f5;
    font-weight: 600;
    padding: 4px 8px;
    border-right: 1px solid #d7c6c6;
}

.name-number-data .cart-data-col td {
    padding: 4px 8px;
    border-top: 1px solid #d7c6c6;
    border-right: 1px solid #d7c6c6;
}

.acc__panel.order-list-page {
    overflow: visible !important;
}

.order-list-page .table-btn-col {
    justify-content: center !important;
}

.mt_8 {
    margin-top: 8px;
}

.color_swatch_byaddr {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    display: inline-block;
    border: 1px solid #ddd;
    border-radius: 2px;
    vertical-align: middle;
    object-fit: cover;
}

.byaddress-total-section.total_price {
    margin-top: 1rem;
}

.byaddress-fee-summary {
    border: 0 !important;
    border-radius: 0;
    padding: 8px 0 4px;
    background: transparent;
    font-family: "Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI",
        sans-serif;
}

.byaddress-total-row {
    flex-wrap: nowrap;
    align-items: center;
    padding: 8px 0;
    min-height: 22px;
}

.byaddress-total-row .total_p_custom {
    min-width: 0;
    flex: 1 1 auto;
}

.byaddress-label {
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
    margin-right: 8px;
    position: relative;
}

/* Regular line item rows */
.byaddress-fee-summary
    .byaddress-total-row:not(.byaddress-subtotal-row):not(
        .byaddress-item-subtotal-row
    )
    .byaddress-label {
    color: #606060;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400 !important;
}

.byaddress-value {
    flex-shrink: 0;
    font-weight: 400;
    text-align: right;
}

.byaddress-fee-summary
    .byaddress-total-row:not(.byaddress-subtotal-row):not(
        .byaddress-item-subtotal-row
    )
    .byaddress-value {
    color: #121212;
    font-size: 16px;
    line-height: 16px;
    font-weight: 400 !important;
    text-align: right;
}

/* Sub Total: border top + bottom, bold */
.byaddress-subtotal-block {
    margin-top: 0;
    padding: 10px 0;
    border-top: 1px solid #bebebe4d;
    border-bottom: 1px solid #bebebe4d;
}

.byaddress-subtotal-row .byaddress-label,
.byaddress-subtotal-row .byaddress-value {
    color: #000000 !important;
    font-weight: 700 !important;
    font-size: 14px;
    line-height: 1.35;
}

/* Item Sub Total: border top, bold */
.byaddress-item-subtotal-block {
    margin-top: 0;
    padding-top: 10px;
    border-top: 1px solid #bebebe4d;
}

.byaddress-item-subtotal-row .byaddress-label,
.byaddress-item-subtotal-row .byaddress-value {
    color: #000000 !important;
    font-weight: 700 !important;
    font-size: 14px;
    line-height: 1.35;
}

.byaddress-grand-total .byaddress-value {
    font-weight: 700;
}

/* col-md-12 spacing inside fee summary */
.byaddress-fee-summary .col-md-12 {
    padding: 0px;
}

.byaddress-fee-summary .col-md-12.byaddress-subtotal-block {
    padding: 0px;
}

.artwork-old-block {
    display: none;
}

/* Tooltip in cost summary: open leftward so it doesn't overflow right edge */
.byaddress-fee-summary .tooltip-content {
    left: auto !important;
    right: 0 !important;
    transform: none !important;
}

/* ===== Items by Address: product item row — matches admin structure ===== */

/* product_details_box: space-between keeps product info left, decorator logo right */
.product_details_box {
    padding-bottom: 12px;
    justify-content: space-between;
}

/* product image box */
.order-list-col .product-box {
    width: 90px !important;
    height: 90px !important;
    min-width: 90px !important;
    min-height: 90px !important;
    max-width: 90px !important;
    max-height: 90px !important;
    padding: 0 !important;
    border: 1px solid #d3d3d3 !important;
    background-color: #f8f8f8 !important;
    margin-right: 16px !important;
    flex-shrink: 0 !important;
    position: relative;
    overflow: hidden;
}

.order-list-col .product-box img.img-fluid {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    display: block !important;
}

/* product number badge below image */
.product_number {
    border: 1px solid #d3d3d3;
    background-color: #f4f4f4;
    max-width: 90px;
    display: block;
    text-align: center;
    font-size: 12px;
    padding: 1px 4px;
}

/* Name/Number table export button: below the table (column-reverse) */
.order-list-page .order-list-col .table-btn-col {
    flex-direction: column-reverse !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    margin-bottom: 20px;
}

.order-list-page .order-list-col .data-export-btn .export-btn {
    margin-top: 20px;
    padding: 8px;
    font-size: 14px;
}
</style>

